'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keySeq2 = require('./internal/_keySeq');

var _keySeq3 = _interopRequireDefault(_keySeq2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get a Seq of the keys in `subject`.
 *
 * @example
 * keySeq({one: 1, two: 2, three: 3})
 * // returns Seq [ 'one', 'two', 'three' ]
 *
 * @param  {Iterable|Object|Array} subject
 * @return {Seq}
 */
exports.default = _keySeq3.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/keySeq.js
// module id = 375
// module chunks = 0 1